/**
 * File: skapedia.ts
 *
 * The site's one Skapedia client. Skapedia (https://www.npmjs.com/package/skapedia)
 * is where the official BunnyQuery articles are published; the site no longer
 * keeps its own copy of them.
 *
 * It is imported in TWO places, and both must use this instance:
 *   - at RUNTIME by articles.ts, for the article list, the article pages, the
 *     news banner and the landing page's news cards;
 *   - at BUILD time by build/seo-plugins.ts, for sitemap.xml, feed.xml, llms.txt
 *     and the static article pages.
 * One instance per place means one cache per place: Skapedia keeps the list
 * pages and the article bodies it has fetched, so nothing is downloaded twice.
 *
 * This module imports nothing but the package, so the build can load it.
 */

import { Skapedia } from "skapedia";

export const skapedia = new Skapedia("bunnyquery");
